<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="8" md="4">
        <v-card class="elevation-12">
          <v-toolbar color="primary" dark flat>
            <v-toolbar-title>Business Login</v-toolbar-title>
            <div class="flex-grow-1"></div>
          </v-toolbar>
          <v-card-text>
            <v-form id="loginform"  >
              <v-alert dense text type="error" v-if="authFailed">
                {{authMessage}}
              </v-alert>
              <v-text-field
                v-model="email"
                label="E-mail"
                name="email"
                prepend-icon="person"
                type="email"
                v-validate="'required|email'"
                :error-messages="errors.collect('email')"
                data-vv-name="email"
                required
              ></v-text-field>

              <v-text-field
                v-model="password"
                id="password"
                label="Password"
                name="password"
                prepend-icon="lock"
                type="password"
                :error-messages="errors.collect('password')"
                data-vv-name="password"
                v-validate="'required'"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn color="primary" @click.prevent="submit">Login</v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import Vue from "vue";
import VeeValidate from "vee-validate";

Vue.use(VeeValidate);
export default {
  
 props: {
    source: String
  },
  data: () => ({
    email: '',
    password: '',
    authFailed: false,
    authMessage: '',
    drawer: null,
    dictionary: {
      attributes: {
        email: 'E-mail Address'
        // custom attributes
      },
      custom: {}
    }
  }),
  mounted() {
    this.$validator.localize('en', this.dictionary);
  },
  computed: {
    isAuthorised() {
      return this.$store.getters.isLoggedin;
    }
    
  },
  created() {
     this.usert=JSON.parse(this.$store.getters.user);
    
    if(this.usert.userType=='agent')
    {
      this.$router.push("/agent/dashboard");
    }
    if(this.usert.userType=='business')
    {
      this.$router.push("/business/dashboard");
    }
  },
  methods: {
   
    submit() {
      
      if(this.$validator.validateAll())
      {
        let email = this.email;
        let password = this.password;
        this.$store
          .dispatch("loginBusiness", { email, password })
          .then(() => {
            if (this.isAuthorised) {
              console.log('Login');
              this.authFailed = false;
              this.authMessage='';
              this.$router.push("/business/dashboard");
            
            }else{
              this.authFailed = true;
              this.authMessage="User not an Business";
              console.log('error');
            }
          })
          .catch(err => {
            console.log('err section');
            this.authFailed = true;
            if (!err.data.success) {
              this.authMessage = err.data.message;
            }
          });
      }
      else{
        
      }
    }
  }
};
</script>

